import { render, staticRenderFns } from "./icon-images.vue?vue&type=template&id=5fb1c8a6"
import script from "./icon-images.vue?vue&type=script&lang=js"
export * from "./icon-images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports